import { SHHtmlBlock, SHStack, SHTypography } from "@components/design-systems";
import { ConfigurationSection } from "@models/configuration";
import { useTheme } from "@mui/material";

export interface SubSectionTitleProps {
  subSection: ConfigurationSection;
}

export default function SubSectionTitle({ subSection }: SubSectionTitleProps) {
  const { palette } = useTheme();
  return (
    <SHStack sx={{ pb: "25px" }}>
      <SHTypography variant="h2" sx={{ fontSize: "24px", fontWeight: 600 }}>
        {subSection?.name}
      </SHTypography>
      <SHHtmlBlock
        variant="body3"
        content={subSection?.description}
        color={palette.text.fourth}
      />
    </SHStack>
  );
}
